import { render, staticRenderFns } from "./MyOSTable.vue?vue&type=template&id=3d309130"
import script from "./MyOSTable.vue?vue&type=script&lang=js"
export * from "./MyOSTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports